import { useState, useEffect } from 'react'

export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches
        }
        return false
    })

    useEffect(() => {
        const media = window.matchMedia(query)

        setMatches(media.matches)

        const listener = (event) => {
            setMatches(event.matches)
        }

        if (media.addEventListener) {
            media.addEventListener('change', listener)
            return () => media.removeEventListener('change', listener)
        } else {
            media.addListener(listener)
            return () => media.removeListener(listener)
        }
    }, [query])

    return matches
}

export default useMediaQuery
